import { cn } from '@/lib/utils';
import { Button } from '../button';
import type { ComponentPropsWithRef, ReactNode } from 'react';

export interface OptionChipProps extends Omit<ComponentPropsWithRef<'button'>, 'disabled'> {
    children: ReactNode;
    discontinued?: boolean;
    isSelected?: boolean;
    isOutOfStock?: boolean;
    className?: string;
}

export const OptionChip = ({
    children,
    discontinued = false,
    isSelected = false,
    isOutOfStock = false,
    className,
    type = 'button',
    ref,
    ...props
}: OptionChipProps) => {
    const variant = isSelected || discontinued ? 'primary' : 'secondary';
    return (
        <Button
            {...props}
            type={type}
            variant={variant}
            disabled={discontinued}
            selected={isSelected}
            className={cn('relative overflow-hidden !tracking-[0.18px] text-[18px] leading-7 normal-case', className)}
            ref={ref}>
            {children}
            {isOutOfStock && !discontinued && (
                <span
                    aria-hidden="true"
                    data-slot="option-chip-strike"
                    className={cn('absolute top-1/2 left-0 h-px w-full rotate-45', {
                        'bg-primary': !isSelected,
                        'bg-secondary': isSelected,
                    })}
                />
            )}
        </Button>
    );
};
